<app-alert></app-alert>

<div class="row mt-2" *ngIf="!isModal">
    <div class="form-group col mb-n1">
        <h1>Assets</h1>
    </div>
</div>

<div class="stretch-right-left library" [ngClass]="{ isModal: isModal }">
    <div class="folders">
        <div class="folders-header">
            <span> Media Library </span>
            <div>
                <button (click)="openNewFolder()">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path
                            fill="currentColor"
                            d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                        ></path>
                    </svg>
                </button>
            </div>
        </div>
        <div class="folders-list">
            <div class="folders-list-item" *ngFor="let item of folders" [ngClass]="{ active: item.active }" (click)="setActiveFolder(item)">
                <span> {{ item.folderName }} </span>
                <div>
                    <button (click)="confirmFolderDelete(item)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path
                                d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="assets ml-4 mr-4">
        <div class="assets-header">
            <div class="left">
                <button class="btn btn-light" (click)="selectAll()">Select All</button>
                <button class="btn btn-light ml-2" (click)="confirmDeleteBulk()" [disabled]="!selected.length">
                    Delete <span class="badge top-init" *ngIf="selected.length">{{ selected.length }}</span>
                </button>
            </div>
            <div class="right">
                <div class="search mr-2">
                    <input placeholder="Filter..." type="search" autofocus="autofocus" [formControl]="searchBoxControl" />
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                            d="M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
                        ></path>
                    </svg>
                </div>
                <button class="btn btn-primary" (click)="file.click()" [disabled]="!selectedFolderId">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path
                            d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                        ></path>
                    </svg>
                    <span> Upload </span>
                </button>
                <input type="file" #file name="file" class="hidden-file-upload" (change)="upload(file.files, $event)" />
            </div>
        </div>

        <ngx-datatable
            #table
            [ngClass]="{ isModal: isModal }"
            class="bootstrap-table media-table mt-2"
            style="height: calc(100vh - 179px); margin-bottom: 100px"
            [rows]="data?.items"
            [headerHeight]="61"
            [footerHeight]="65"
            [rowHeight]="'auto'"
            [columnMode]="'standard'"
            [scrollbarH]="true"
            [scrollbarV]="true"
            [selected]="selected"
            [selectionType]="'single'"
            [externalPaging]="true"
            [externalSorting]="true"
            [virtualization]="false"
            [count]="data?.totalItems"
            [offset]="params.page"
            [limit]="5"
            (select)="tableSelect($event)"
            (page)="tablePaging($event)"
            (sort)="tableSorting($event)"
        >
            <ngx-datatable-column
                name="Image"
                prop="imagePath"
                [cellClass]="'tb-col-2'"
                [headerClass]="'tb-col-2'"
                [sortable]="false"
                [draggable]="false"
                [resizeable]="false"
            >
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    <img src="/thumbs/{{ row.assetId }}/small/{{ row.assetFriendlyName }}" />
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Name" prop="assetName" [cellClass]="'tb-col-2'" [headerClass]="'tb-col-2'" [draggable]="false" [resizeable]="false">
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    <div>
                        <span>
                            {{ value }}
                        </span>
                        <div class="media-btns mt-1">
                            <button class="btn-link" (click)="openEditAsset(row)">Edit</button>
                            <button class="btn-link ml-3" (click)="confirmDelete(row)">Delete</button>
                            <a class="btn-link ml-3" [routerLink]="['/thumbs', row.assetId, 'large', row.assetFriendlyName]" target="_blank"> View </a>
                        </div>
                    </div>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
                name="Size"
                prop="size"
                [cellClass]="'tb-col-2'"
                [headerClass]="'tb-col-2'"
                [sortable]="false"
                [draggable]="false"
                [resizeable]="false"
            >
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    {{ formatBytes(row) }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
                name="Type"
                prop="type"
                [cellClass]="'tb-col-2'"
                [headerClass]="'tb-col-2'"
                [sortable]="false"
                [draggable]="false"
                [resizeable]="false"
            >
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    {{ value }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-footer>
                <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-curPage="curPage">
                    <datatable-pager
                        [pagerLeftArrowIcon]="'datatable-icon-left'"
                        [pagerRightArrowIcon]="'datatable-icon-right'"
                        [pagerPreviousIcon]="'datatable-icon-prev'"
                        [pagerNextIcon]="'datatable-icon-skip'"
                        [page]="curPage"
                        [size]="pageSize"
                        [count]="rowCount"
                        [hidden]="!(rowCount / pageSize > 1)"
                        (change)="table.onFooterPage($event)"
                    >
                    </datatable-pager>
                </ng-template>
            </ngx-datatable-footer>
        </ngx-datatable>
    </div>
</div>
